import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import { POST_EXAM_FEE_ADMISSION_LEVEL_URL } from '../../constants/apiUrls';
import {GenericErrorResponse, KeyValueResponse} from '../typings';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ExamFeeAdmissionLevelRequest {
  registrationExamLevelUuid: string;
  year: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: KeyValueResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostExamFeeAdmissionLevel = ({ onSuccess, onError }: Input) => {
  const postExamFeeAdmissionLevel = async (payload: ExamFeeAdmissionLevelRequest) => {
    const res = await axiosClient.post<KeyValueResponse[]>(
      POST_EXAM_FEE_ADMISSION_LEVEL_URL,
      payload
    );
    return res.data;
  };

  return useCustomMutation(postExamFeeAdmissionLevel, {
    onSuccess,
    onError,
  });
};
